import React, { useMemo, useState } from "react";
import { BlueBirdTheme, Button, Loading } from "@kitbird/core";
import { ColumnI } from "../../../../../components/Table/TableProps";
import { ReactComponent as EditIcon } from "../../../../../assets/icons/edit.svg";
import { ReactComponent as TrashIcon } from "../../../../../assets/icons/trash.svg";
import Table from "../../../../../components/Table";
import useDepartment from "../../useDepartment";
import { listCodeTypeAll } from "../../../../Transaction/CreateReceiptSubmission/constants";
import { IGetMasterDepartmentData } from "../../../../../services/masterDepartmentService";

interface DepartmentTableProps {
  setEditValue: React.Dispatch<React.SetStateAction<IGetMasterDepartmentData | undefined>>;
  showModal: () => void;
  showDeleteModal: () => void;
  useCustomHook: ReturnType<typeof useDepartment>,
}

const { primary, danger } = BlueBirdTheme.colors;

const DepartmentTable = ({
  setEditValue, showModal, showDeleteModal, useCustomHook,
}: DepartmentTableProps) => {
  const {
    params,
    setParams,
    masterDepartmentList,
    isFetching,
  } = useCustomHook;
  const renderActions = (item: any, row: Record<string, any>) => (
    <div style={{ display: "flex", gap: 8 }}>
      <Button
        style={{ padding: "8px 10px" }}
        backgroundColor={primary[300]}
        onClick={() => {
          setEditValue(row as IGetMasterDepartmentData);
          showModal();
        }}
      >
        <EditIcon width={16} height={16} />
      </Button>
      <Button
        style={{ padding: "8px 10px" }}
        backgroundColor={danger[400]}
        onClick={() => {
          setEditValue(row as IGetMasterDepartmentData);
          showDeleteModal();
        }}
      >
        <TrashIcon width={16} height={16} />
      </Button>
    </div>
  );

  const columns: ColumnI[] = useMemo(() => [
    {
      title: "Tipe user",
      dataIndex: "code_type",
      key: "code_type",
      width: "100px",
      render: (item) => (listCodeTypeAll.find((type) => type.code_type === item)?.code_type_desc),
    },
    {
      title: "Departemen",
      dataIndex: "department",
      key: "department",
      width: "200px",
      sort: true,
    },
    {
      title: "Deskripsi",
      dataIndex: "department_desc",
      key: "department_desc",
      width: "200px",
    },
    {
      title: "Departemen cost",
      dataIndex: "department_cost",
      key: "department_cost",
      width: "200px",
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      width: "100px",
      render: renderActions,
    },
  ], []);

  return (
    isFetching
      ? <Loading variant="line" />
      : <Table
        withNumber
        columns={columns}
        dataSource={masterDepartmentList}
        sortConfig={{
          sortType: params.sortType,
          sortBy: params.sortBy,
          onSort: (name, type) => setParams((curr) => ({ ...curr, sortBy: name, sortType: type })),
        }}
      />
  );
};

export default DepartmentTable;
